<template>
    <section class="gridExpander transition-all" :class="{ closed:isClosed }">
        <div class="overflow-hidden" :class="innerClass">
            <slot></slot>
        
        </div>
    </section>
</template>

<script setup>
const props = defineProps({
    isClosed: {
        type: Boolean,
        default: true,
    },
    innerClass: {
        type: String,
        default: 'overflow-hidden'
    }
})
</script>

<style lang="scss" scoped>
.gridExpander{
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
}

.closed{
    grid-template-rows: 0fr;
    grid-template-columns: 0fr;
}
</style>